export const STATISTIC_CARD_CHART_HEIGHT = 110

export const STATISTIC_CARD_CHART_BACKGROUND_COLOR = '#F8F9FA80'

export const STATISTIC_CARD_CHART_TICK_COLOR = '#ADB5BD'
